import axios from 'axios'
import { mock } from '../mock'
import siteConfig from 'siteConfig'
import { authInterceptor, languageInterceptor, countryInterceptor, currencyInterceptor, timestampInterceptor } from './interceptors'
import resources from './resources'
import store from 'store'
import router from '@/router'
import auth from 'utilities/udi/udi'

const apiEndpointBaseUrl = siteConfig.ApiHost
const qs = require('qs')

export const instance = axios.create({
  baseURL: apiEndpointBaseUrl,
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json',
    'Philips-Language': 'nl-NL',
    'Philips-Country': 'NL',
    'Philips-Currency': 'EUR'
  }
})

instance.interceptors.request.use(timestampInterceptor)
instance.interceptors.request.use(authInterceptor)
instance.interceptors.request.use(languageInterceptor)
instance.interceptors.request.use(countryInterceptor)
instance.interceptors.request.use(currencyInterceptor)

instance.interceptors.request.use((config) => {
  if (config.method === 'get') {
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

instance.interceptors.response.use(
  response => {
    let userToken = response.headers && response.headers['philips-user-token']
    if (userToken && store.state.account.token) {
      store.commit('account/setToken', userToken)
    }
    return response
  },
  error => {
    if (error.response.status && error.response.status === 401) {
      const email = store.state.account.profile.personalDetail.email
      store.commit('account/deleteToken')
      store.dispatch('account/reset')
      auth.login({
        returnUrl: router.currentRoute.fullPath,
        email
      })
    } else if (error.response.data && error.response.data.code === 'error.message.userIsNotBelongTo') {
      store.commit('account/deleteToken')
      store.dispatch('account/reset')
      auth.login()
    }

    return Promise.reject(error.response)
  }
)

export default function (option) {
  if (option && option.mock) {
    mock(instance)
  }
  let apiResources = {}
  Object.entries(resources).forEach(([key, factory]) => {
    apiResources[key] = factory(instance)
  })
  return apiResources
}
